import _classCallCheck from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { CloudinaryFile } from "./CloudinaryFile.js";
import { DeliveryFormatAction } from "@cloudinary/transformation-builder-sdk/actions/delivery/DeliveryFormatAction";
/**
 * @desc Cloudinary Transformable interface, extended by any class that needs a Transformation Interface
 * @summary SDK
 * @memberOf SDK
 */

var CloudinaryTransformable = /*#__PURE__*/function (_CloudinaryFile) {
  _inherits(CloudinaryTransformable, _CloudinaryFile);

  var _super = _createSuper(CloudinaryTransformable);

  function CloudinaryTransformable(publicID, cloudConfig, urlConfig, transformation) {
    var _this;

    _classCallCheck(this, CloudinaryTransformable);

    /* istanbul ignore next */
    _this = _super.call(this, publicID, cloudConfig, urlConfig);
    _this.transformation = transformation;
    return _this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Animated} animated
   * @return {this}
   */


  _createClass(CloudinaryTransformable, [{
    key: "animated",
    value: function animated(_animated) {
      this.transformation.animated(_animated);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.Border} border
     * @return {this}
     */

  }, {
    key: "border",
    value: function border(_border) {
      this.transformation.border(_border);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.Reshape} reshape
     * @return {this}
     */

  }, {
    key: "reshape",
    value: function reshape(_reshape) {
      this.transformation.reshape(_reshape);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.Resize} resize
     * @return {this}
     */

  }, {
    key: "resize",
    value: function resize(_resize) {
      this.transformation.resize(_resize);
      return this;
    }
    /**
     * @desc An alias to Action Delivery.quality
     * @param {string|number} quality
     * @return {this}
     */

  }, {
    key: "quality",
    value: function quality(_quality) {
      this.addAction(new DeliveryFormatAction('q', _quality));
      return this;
    }
    /**
     * @desc An alias to Action Delivery.format
     * @param {string} format
     * @return {this}
     */

  }, {
    key: "format",
    value: function format(_format) {
      this.addAction(new DeliveryFormatAction('f', _format));
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.RoundCorners} roundCorners
     * @return {this}
     */

  }, {
    key: "roundCorners",
    value: function roundCorners(_roundCorners) {
      this.transformation.roundCorners(_roundCorners);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @return {this}
     */

  }, {
    key: "overlay",
    value: function overlay(overlayAction) {
      this.transformation.overlay(overlayAction);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.Variable} variableAction
     * @return {this}
     */

  }, {
    key: "addVariable",
    value: function addVariable(variableAction) {
      this.transformation.addVariable(variableAction);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.Condition} conditionalAction
     * @return {this}
     */

  }, {
    key: "conditional",
    value: function conditional(conditionalAction) {
      this.transformation.conditional(conditionalAction);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.Effect} effect
     * @return {this}
     */

  }, {
    key: "effect",
    value: function effect(_effect) {
      this.transformation.effect(_effect);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.Adjust} action
     * @return {this}
     */

  }, {
    key: "adjust",
    value: function adjust(action) {
      this.transformation.adjust(action);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.Rotate} rotate
     * @return {this}
     */

  }, {
    key: "rotate",
    value: function rotate(_rotate) {
      this.transformation.rotate(_rotate);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.NamedTransformation} namedTransformation
     * @return {this}
     */

  }, {
    key: "namedTransformation",
    value: function namedTransformation(_namedTransformation) {
      this.transformation.namedTransformation(_namedTransformation);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.Delivery} deliveryAction
     * @return {this}
     */

  }, {
    key: "delivery",
    value: function delivery(deliveryAction) {
      this.transformation.delivery(deliveryAction);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Qualifiers.color} color
     * @return {this}
     */

  }, {
    key: "backgroundColor",
    value: function backgroundColor(color) {
      this.transformation.backgroundColor(color);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.PSDTools} action
     * @return {this}
     */

  }, {
    key: "psdTools",
    value: function psdTools(action) {
      this.transformation.psdTools(action);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.Extract} action
     * @return {this}
     */

  }, {
    key: "extract",
    value: function extract(action) {
      this.transformation.extract(action);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Qualifiers.Flag | string} flagQualifier
     * @return {this}
     */

  }, {
    key: "addFlag",
    value: function addFlag(flagQualifier) {
      this.transformation.addFlag(flagQualifier);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.CustomFunction} customFunction
     * @return {this}
     */

  }, {
    key: "customFunction",
    value: function customFunction(_customFunction) {
      this.transformation.customFunction(_customFunction);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {SDK.Action | string} action
     * @return {this}
     */

  }, {
    key: "addAction",
    value: function addAction(action) {
      this.transformation.addAction(action);
      return this;
    }
    /**
     * @description Extend your transformation with another transformation
     * @param { string | SDK.Transformation } tx
     */

  }, {
    key: "addTransformation",
    value: function addTransformation(tx) {
      this.transformation.addTransformation(tx);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.transformation.toString();
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @return {this}
     */

  }, {
    key: "underlay",
    value: function underlay(underlayAction) {
      this.transformation.underlay(underlayAction);
      return this;
    }
  }, {
    key: "toURL",
    value: function toURL() {
      var overwriteOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.createCloudinaryURL(this.transformation, overwriteOptions === null || overwriteOptions === void 0 ? void 0 : overwriteOptions.trackedAnalytics);
    }
  }]);

  return CloudinaryTransformable;
}(CloudinaryFile);

export { CloudinaryTransformable };